<template>
  <AppPercent :value="ctr" />
</template>

<script>
export default {
  name: 'AppCtr',
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ctr() {
      // 小数3桁四捨五入の%表記
      return Math.floor(this.value * 10000) / 100
    },
  },
}
</script>
